import { useEffect, useRef, useState } from 'react';
import { cn } from '@/lib/utils';
import { SiteContainer, SiteMockSlot } from '../SiteUi';

const STEPS = [
  {
    n: '01',
    kicker: 'Serviço',
    title: 'Finalizado',
    visual: (
      <SiteMockSlot>
        <div className="flex items-center justify-between">
          <span className="font-os">OS-1042</span>
          <span className="text-[11px] font-semibold text-[#1f6b43]">ok</span>
        </div>
        <p className="mt-2 text-[#5c5852]">Troca de óleo · Gol</p>
      </SiteMockSlot>
    ),
  },
  {
    n: '02',
    kicker: 'AgilizaOS',
    title: 'Aguarda',
    visual: (
      <SiteMockSlot>
        <div className="flex items-center justify-between">
          <span className="font-os">OS-1042</span>
          <span className="text-[11px] font-semibold text-[#f5821f]">90 dias</span>
        </div>
        <p className="mt-2 text-[#5c5852]">intervalo da oficina</p>
      </SiteMockSlot>
    ),
  },
  {
    n: '03',
    kicker: 'WhatsApp',
    title: 'Envia',
    visual: (
      <SiteMockSlot className="bg-[#ece5dd]">
        <div className="rounded bg-white px-2 py-2 text-[#16181d] shadow-sm">
          Faz um tempo que não cuidamos do seu ABC-1234.
        </div>
      </SiteMockSlot>
    ),
  },
  {
    n: '04',
    kicker: 'Cliente',
    title: 'Volta',
    visual: (
      <SiteMockSlot>
        <p className="font-medium">João · 18/11, 09:30</p>
        <p className="mt-2 font-os text-[#1f6b43]">+ R$ 189,90</p>
      </SiteMockSlot>
    ),
  },
];

export function SiteHowItWorks() {
  const ref = useRef<HTMLElement>(null);
  const [active, setActive] = useState(3);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
      setActive(3);
      return;
    }

    const onScroll = () => {
      const rect = el.getBoundingClientRect();
      const start = window.innerHeight * 0.72;
      const progress = (start - rect.top) / (rect.height * 0.7);
      const step = Math.min(3, Math.max(0, Math.floor(progress * 4)));
      setActive(step);
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <section id="como-funciona" ref={ref} className="scroll-mt-24 py-20 sm:py-28">
      <SiteContainer>
        <p className="text-sm text-[#5c5852]">Da OS ao próximo atendimento</p>
        <h2 className="mt-3 max-w-[18ch] font-display text-[clamp(2rem,4vw,3.25rem)] font-semibold tracking-tight text-[#16181d]">
          O serviço termina. O relacionamento continua.
        </h2>

        <ol className="mt-16 grid items-stretch gap-8 sm:grid-cols-4">
          {STEPS.map((step, index) => (
            <li
              key={step.n}
              className={cn(
                'relative flex flex-col border-t border-[#d9d4cc] pt-6 transition-opacity duration-200',
                index <= active ? 'opacity-100' : 'opacity-40',
              )}
            >
              <p className="font-os text-xs tracking-[0.2em] text-[#f5821f]">{step.n}</p>
              <p className="mt-4 text-sm uppercase tracking-[0.16em] text-[#5c5852]">{step.kicker}</p>
              <p className="mt-2 font-display text-2xl font-semibold leading-none text-[#16181d]">{step.title}</p>
              <div className="mt-5">{step.visual}</div>
            </li>
          ))}
        </ol>
      </SiteContainer>
    </section>
  );
}
